import { render, staticRenderFns } from "./UsersTab.vue?vue&type=template&id=2771bfb4&scoped=true"
import script from "./UsersTab.vue?vue&type=script&lang=js"
export * from "./UsersTab.vue?vue&type=script&lang=js"
import style0 from "./UsersTab.vue?vue&type=style&index=0&id=2771bfb4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771bfb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2771bfb4')) {
      api.createRecord('2771bfb4', component.options)
    } else {
      api.reload('2771bfb4', component.options)
    }
    module.hot.accept("./UsersTab.vue?vue&type=template&id=2771bfb4&scoped=true", function () {
      api.rerender('2771bfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/components/UsersTab.vue"
export default component.exports